import { ReactNode } from 'react';
import styled from 'styled-components';

interface LaunchesBannerWrapperProps {
  className?: string;
  children: ReactNode;
}
const LaunchesBannerWrapper = ({
  children,
  className
}: LaunchesBannerWrapperProps) => {
  return <Container className={className}>{children}</Container>;
};

const Container = styled.div`
  padding: 32px 0;
  grid-column: 1/-1;
`;

export default LaunchesBannerWrapper;
